"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonToastNotification = void 0;
const React = require("react");
const BronsonToastNotification = (props) => {
    let timer;
    const tenThousand = 10000;
    React.useEffect(() => {
        if (props.isVisible && props.autoClose !== false) {
            timer = setTimeout(() => props.setVisibility && props.setVisibility(false), props.timeToBeDisplay ? props.timeToBeDisplay : tenThousand);
        }
    }, [props.isVisible]);
    const renderCloseButton = () => props.isClosable ? (React.createElement("button", { className: 'c-toast-notification__close  c-icon  c-icon--[semantic-close]', type: 'button', title: 'Cerrar notificaci\u00F3n', onClick: () => {
            if (props.setVisibility)
                props.setVisibility(false);
            if (timer)
                clearTimeout(timer);
        } })) : (React.createElement(React.Fragment, null));
    return (React.createElement("aside", { className: 'c-toast-notifications', "aria-label": `${props.label ? props.label : ''}` },
        React.createElement("article", { className: `c-toast-notification  c-toast-notification--${props.type} ${props.isVisible ? '' : 'is-closed'}`, "aria-live": 'polite', role: 'status' },
            React.createElement("div", { className: 'c-toast-notification__content' },
                React.createElement("div", { className: 'c-toast-notification__body' },
                    React.createElement("p", null, props.content)),
                renderCloseButton()))));
};
exports.BronsonToastNotification = BronsonToastNotification;
